const updates = [
  { date: '07-30', label: '今日上新', title: '《长安十二时辰》全集上线，4K修复版画面惊艳', tag: '热播', tagColor: 'bg-accent-500' },
  { date: '07-29', label: '片库更新', title: '暑期档热门电影专题上线，喜剧动作悬疑一网打尽', tag: '推荐', tagColor: 'bg-primary-500' },
  { date: '07-28', label: '技术升级', title: '播放引擎全面优化，4K高清秒加载不缓冲体验升级', tag: '系统', tagColor: 'bg-secondary-500' },
  { date: '07-27', label: '新片速递', title: '《流浪地球3》独家幕后花絮与制作特辑已上线', tag: '独家', tagColor: 'bg-accent-500' },
  { date: '07-26', label: '综艺上新', title: '《这！就是街舞》第七季完整版高清全集持续更新中', tag: '热播', tagColor: 'bg-accent-500' },
  { date: '07-25', label: '经典回归', title: '张国荣经典影片修复专区上线，《霸王别姬》4K首发', tag: '经典', tagColor: 'bg-primary-500' },
  { date: '07-24', label: '片单推荐', title: '「悬疑烧脑」主题片单：十部高能反转电影不容错过', tag: '策划', tagColor: 'bg-secondary-500' },
  { date: '07-23', label: '功能上线', title: '多设备无缝续播功能开放，手机平板电视随意切换', tag: '功能', tagColor: 'bg-secondary-500' },
  { date: '07-22', label: '动漫上新', title: '2026夏季新番专题上线，热门日漫国漫同步更新中', tag: '新番', tagColor: 'bg-accent-500' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="relative py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">最新动态</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">片库实时更新，热播剧集与经典影片第一时间上线</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300/50 md:-translate-x-px"></div>

          <div className="space-y-8 md:space-y-6">
            {updates.map((item, idx) => (
              <div key={idx} className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                <div className="hidden md:flex flex-1" />
                <div className="absolute left-0 md:left-1/2 w-8 h-8 md:-translate-x-1/2 flex items-center justify-center">
                  <div className="w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                </div>
                <div className="flex-1 pl-12 md:pl-0 md:px-8">
                  <div className="bg-background-200/50 rounded-xl p-5 border border-background-200/60 hover:border-primary-500/20 transition-colors">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-xs text-foreground-600 font-mono">{item.date}</span>
                      <span className="text-xs text-foreground-500">{item.label}</span>
                      <span className={`px-2 py-0.5 rounded text-[10px] font-medium text-background-50 whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
                    </div>
                    <p className="text-foreground-200 text-sm md:text-base leading-relaxed">{item.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}